import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ProductService } from '../services/product.service';
import { firstValueFrom } from 'rxjs';
import { GetCurrentUserData } from '../../../../core/store/current-user/current-user.state';
import { ProductDataService } from '../services/product-data.service';
import { SnackbarService } from '../../../../core/services/snackbar.service';
import { CustomPortalError } from '../../../../core/errors/models/CustomPortalError';

export const activationResolver = async () => {
  const store = inject(Store);
  const productService = inject(ProductService);
  const productDataService = inject(ProductDataService);
  const snackbarService = inject(SnackbarService);

  try {
    const [, topicAreas] = await Promise.all([
      firstValueFrom(store.dispatch(new GetCurrentUserData())),
      firstValueFrom(productService.getTopicAreas()),
    ]);
    productDataService.topicAreas.set(topicAreas);
    await productDataService.getProductDetails();
  } catch (e) {
    snackbarService.error((e as CustomPortalError).errorType);
  }
};
